import React from "react";

/**
 * Represents an information bubble component that displays a message, support message, and optional action text.
 *
 * @param {Object} props - The component's input properties.
 * @param {string} props.message - The primary message to display in the information bubble.
 * @param {boolean} [props.support=null] - Indicates whether the support section is active or not.
 * @param {string} props.supportMessage - The support message text to display when `support` is active.
 * @param {function} props.onActionClick - Callback function to handle click events on the support action.
 * @param {Object} [props.overrideSupportStyle=null] - Optional custom style object to override the default support styling.
 * @param {string} [props.supportActionText=null] - Optional text for the support action link. If not provided, the support action link will not render.
 *
 * @returns {JSX.Element|null} A rendered information bubble component or null if no messages or action text are provided.
 */
const InformationBubble = ({ message, support, supportMessage, onActionClick, overrideSupportStyle = null, supportActionText }) => {
    if (!message && !supportMessage && !supportActionText) return null;

    return (
        <div
            style={overrideSupportStyle ? overrideSupportStyle : {
                flexDirection: 'row',
                display: 'flex',
                justifyContent: 'center',
                paddingTop: 5,
                borderWidth: 1,
                borderStyle: 'solid',
            }}>
            {support ? (
                <div style={{flex: 1, column: 'row'}}>
                    <div
                        style={{
                            flex: 1,
                            maxWidth: '100%',
                            color: '#707070',
                            fontSize: 15,
                            textAlign: 'center',
                        }}>
                        {supportMessage}
                    </div>
                    {supportActionText ? (
                        <div
                            onClick={() => onActionClick()}
                            style={{
                                flex: 1,
                                maxWidth: '100%',
                                paddingTop: 5,
                                color: '#2EB4FF',
                                fontSize: 15,
                                textDecoration: 'underline',
                                cursor: 'pointer',
                                textAlign: 'center',
                            }}>
                            {supportActionText}
                        </div>
                    ) : null}
                </div>
            ) : (
                <div
                    style={{
                        flex: 1,
                        maxWidth: '100%',
                        color: '#707070',
                        fontSize: 15,
                        textAlign: 'center',
                    }}>
                    {message}
                </div>
            )}
        </div>
    );
};

export default InformationBubble;
